import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    isolated: Port.isolated.validator.default(false),
}).default({
    powerFlowDirection: 'bidirectional',
});

const ConnectorBase = z.object({
    type: z.literal('connector').default('connector'),
    electrical: z
        .object({
            ports: z.array(port).min(1).max(1).default([{}]),
        })
        .default({}),
});

export const ConnectorValidator = ComponentValidator.merge(ConnectorBase);
export const ConnectorPayloadValidator = ComponentPayloadValidator.merge(ConnectorBase);

export const ConnectorDefinition: ComponentDefinition = {
    type: 'connector',
    name: 'Connector',
    plural: 'Connectors',
    indicator: 'IO',
    allowCustomIcon: true,
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    searchable: false,
    ports: {
        min: 1,
        max: 1,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: ConnectorValidator,
        payload: ConnectorPayloadValidator,
    },
};

export type Connector = z.infer<typeof ConnectorValidator>;
export type ConnectorPayload = z.infer<typeof ConnectorPayloadValidator>;
